/* eslint-disable no-unused-expressions */
import { useEffect, useRef } from 'react';

function useInterval(callback, delay, immediate = true) {
  const savedCallback = useRef<Function>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback?.current();
    }

    if (delay !== null) {
      if (immediate) {
        tick();
      }
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default useInterval;
